<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" :absolute="false" />
    <v-row no-gutters class="mt-2 mb-3">
      <v-col cols="12" md="9">
        <h2>
          {{ sklypaiTitle
          }}<el-tooltip
            inline
            :tooltip="aprasymasTooltip"
            external
            @activate="
              eventPayload => showAprasymas(eventPayload, aprasymasTooltip)
            "
          />
        </h2>
      </v-col>
      <v-col cols="12" md="3" class="text-right">
        <el-button v-if="showToList" @click.native="toList()" x-small>{{
          $t('Grįžti į sąrašą')
        }}</el-button>
      </v-col>
    </v-row>
    <div class="paslauga-aprasymas">
      <el-paslauga-aprasymas
        :tooltip="paslaugaAprasymas"
        @close="hideAprasymas"
      />
    </div>

    <v-data-table
      class="mt-4"
      :loading="loading"
      :headers="filteredHeaders"
      :items="filteredItemsList"
      :search="search"
      :custom-filter="customSearch"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template #[`header.pasirinkti`]="{ header }">
        {{ header.text }}
        <el-checkbox
          align-self="center"
          class="align-center justify-center mt-0"
          label=""
          v-model="headerCheck"
          @click.native.stop="checkAll()"
        />
      </template>
      <template #[`item.pasirinkti`]="{ item }">
        <div class="text-center mb-2">
          <el-checkbox
            label=" "
            v-model="pasirinkti"
            :checkValue="item.turtas_id"
            :key="`turtas-${item.turtas_id}`"
          />
        </div>
      </template>
      <template #[`item.registras`]="{ item }">
        <div class="nowrap">{{ item.registras }}</div>
      </template>
      <template #[`item.unikalus_nr`]="{ item }">
        <div class="nowrap">{{ item.unikalus_nr }}</div>
      </template>
      <template #[`item.tipas`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            {{ item.tipas }}
          </v-col>
          <v-col cols="12" md="12">
            <span class="text-gray">{{ item.adresas }}</span>
          </v-col>
        </v-row>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        <div class="text-black">
          <el-savitarna-alert dense outlined type="warning2">
            {{ turtaiWarning }}
          </el-savitarna-alert>
        </div>
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-footer class="form-footer">
      <el-button
        v-if="validate('Tęsti')"
        primary
        :disabled="!enableSubmit"
        @click.native="saveData()"
        :loading="loading"
        >{{ $t('Tęsti') }}</el-button
      >
      <el-button
        v-if="validate('Atšaukti')"
        @click.native="cancelData()"
        :loading="loading"
        >{{ $t('Atšaukti') }}</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PazymaMap from './PazymaMap'
import pazymaVeiksmas from './pazymaVeiksmas'

export default {
  name: 'SklypasTurtas',
  mixins: [pazymaVeiksmas],
  props: {
    pazymaKodas: String,
  },
  data() {
    return {
      pageloading: true,
      loading: false,

      paslaugaAprasymas: null,

      search: null,
      searchData: {},
      turtai: [],
      yra_igaliotinis: false,

      pasirinkti: [],
      headerCheck: false,

      itemsPerPageOptions: [10, 50, 100, -1],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['listInfo']),
    headers() {
      return [
        {
          text: this.$t('Pasirinkti'),
          align: 'center',
          sortable: false,
          value: 'pasirinkti',
          width: 60,
        },
        {
          text: this.$t('Registro numeris'),
          align: 'start',
          sortable: false,
          value: 'registras_nr',
          width: 100,
        },
        {
          text: this.$t('Unikalus numeris'),
          align: 'start',
          sortable: false,
          value: 'unikalus_nr',
          width: 150,
        },
        {
          text: this.$t('Turto rūšis'),
          align: 'start',
          sortable: false,
          value: 'tipas',
        },
        {
          text: this.$t('Savininkas'),
          align: 'start',
          sortable: false,
          value: 'savininkas',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filteredItemsList() {
      let eil_nr = 1

      return this.turtai.map(turtas => {
        turtas.eil_nr = eil_nr++

        if (turtas.plotas && turtas.plotas[0] == '.') {
          turtas.plotas = '0' + turtas.plotas
        }

        return turtas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    pazymaMap() {
      return PazymaMap.getPazymaTipas(this.pazymaKodas)
    },
    pazymaTipas() {
      return this.pazymaMap.tipas
    },
    sklypaiTitle() {
      return this.pazymaMap.sklypaiTitle
    },
    pazymaRouteList() {
      return this.pazymaMap.routeList
    },
    pazymaRouteEdit() {
      return this.pazymaMap.routeEdit
    },
    aprasymasTooltip() {
      return `${this.pazymaTooltipPrefix} Anotacija`
    },
    pazymaTooltipPrefix() {
      return this.pazymaMap.tooltipPrefix
    },
    turtaiWarning() {
      if (this.yra_igaliotinis) {
        return this.pazymaMap.turtaiIgaliojimasWarning
      }
      return this.pazymaMap.turtaiWarning
    },
    showToList() {
      return this.listInfo.pazymaKodas === this.pazymaKodas
    },
    enableSubmit() {
      return this.pasirinkti.length > 0
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true

      this.$axios
        .get(`ntrpaslaugos/pazyma/sklypas/turtas`)
        .then(res => {
          if (res.data.redirect) {
            this.editPazyma(res.data.redirect)
            return
          }
          this.turtai = res.data.sklypo_turtas
          this.pagination.total = this.turtai.length
          this.yra_igaliotinis = res.data.yra_igaliotinis
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.$emit('loaded', this.turtai.length)
        })
    },
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          const data = {
            pazyma_tipas: this.pazymaKodas,
            pasirinktas_turtas: this.pasirinkti,
          }
          this.$axios
            .post(`ntrpaslaugos/pazyma/sklypas/turtas`, data)
            .then(res => {
              this.editPazyma(res.data.pazyma)
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    cancelData() {
      this.$router.push({
        name: this.pazymaRouteList,
        params: {
          pazymaKodas: this.pazymaKodas,
        },
      })
    },
    editPazyma(pazyma) {
      const pazymaID = pazyma.paz_id
      this.$store.dispatch('pazymaID', pazymaID).then(
        this.$store.dispatch('pazymaTipas', pazyma.paz_tipas).then(() => {
          const listInfo = {
            pazymaID: pazymaID,
            routeName: this.pazymaRouteList,
          }
          this.$store.dispatch('listInfo', listInfo).then(() => {
            this.$router.push({
              name: this.pazymaRouteEdit,
              params: {
                pazymaID: pazymaID,
              },
            })
          })
        })
      )
    },
    showAprasymas(tipas) {
      this.paslaugaAprasymas = tipas
    },
    hideAprasymas() {
      this.paslaugaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
    toList() {
      this.$router.push({
        name: this.listInfo.routeName,
        params: {
          toList: true,
        },
      })
    },
    checkAll() {
      this.pasirinkti = []
      if (this.headerCheck) {
        this.turtai.forEach(item => {
          if (!this.search || this.customSearch(null, this.search, item)) {
            this.pasirinkti.push(item.turtas_id)
          }
        })
      }
    },
    customSearch(value, search, item) {
      return Object.values(item).some(
        v =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search.toLowerCase())
      )
    },
  },
}
</script>
<style lang="scss" scoped></style>
